import { Calendar } from '../model/Calendar'
import { RoomRule } from '../model/Calendar/RoomRule'
import { Device } from '../model/Device'
import { Room } from '../model/Device/Room'
import { Router } from '../model/Device/Router'
import { Route } from '../model/Device/Router/Route'

interface IRoom {
  roomId: string
  name: string
  door: string
  floor: string
}

interface IDevice {
  deviceId: string
  roomIds: string[]
  routerId: string
}

interface IRouter {
  routerId: string
  routes: IRoute[]
}

interface IRoute {
  roomId: string
  distance: string
  direction: string
}

interface ICalendar {
  url: string
  roomRules: IRoomRule[]
}

interface IRoomRule {
  locationRegEx: string
  roomId: string
}

export interface IConfig {
  rooms: IRoom[]
  routers: IRouter[]
  devices: IDevice[]
  calendars: ICalendar[]
}

export const parseDevice = (config: IConfig, deviceId: string): Device => {
  let router: Router = null

  if (typeof config.devices === undefined) {
    throw new Error('Devices are not defined in config.')
  }

  const rooms: Room[] = config.rooms.map((room: IRoom) => new Room(
    room.roomId,
    room.name,
    room.door,
    room.floor,
  ))

  const device: IDevice = config.devices.find((d: IDevice) => d.deviceId === deviceId)

  if (!device) {
    throw new Error(`${deviceId} was not found in devices config.`)
  }

  const routerConfig: IRouter = config.routers.find((r: IRouter) => r.routerId === device.routerId)

  if (routerConfig) {
    router = new Router(
      routerConfig.routerId,
      routerConfig.routes.map((route: IRoute) => new Route(
        rooms.find((r: Room) => route.roomId === r.id),
        route.distance,
        route.direction,
      )),
    )
  } else if (device.routerId && !routerConfig) {
    throw new Error(`${device.routerId} was not found in routers config.`)
  }

  return new Device(
    device.deviceId,
    rooms.filter((room: Room) => device.roomIds.includes(room.id)),
    router,
  )
}

export const parseCalendars = (calendars: ICalendar[]): Calendar[] => {
  if (typeof calendars === undefined) {
    return []
  }

  return calendars.map((calendar: ICalendar) => new Calendar(
    calendar.url,
    calendar.roomRules.map((roomRule: IRoomRule) => new RoomRule(roomRule.locationRegEx, roomRule.roomId)),
  ))
}
